import { useMarketConfigs } from '../../features/settings';
import { MarketCard } from './MarketConfigCard';

export function MarketsPage() {
  const { items, loading, savingMarketId, error, reload, save } = useMarketConfigs();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-6 w-6 rounded-full border-2 border-gray-300 border-t-primary animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-20 text-center">
        <p className="mb-3 text-sm text-red-500">{error}</p>
        <button onClick={reload} className="text-sm text-primary hover:underline">重试</button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl space-y-5">
      <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-800">
        维护各地区的名称、语言和币种。提现金额及支付通道请到「自动打款」按地区配置。
      </div>
      <div className="space-y-5">
        {items.map((item) => (
          <MarketCard
            key={item.market_id}
            item={item}
            saving={savingMarketId === item.market_id}
            onSave={save}
          />
        ))}
      </div>
    </div>
  );
}
